import { Component } from 'react';
import verifiedImg from '../../assets/images/emc/verified.svg';
import linkImg from '../../assets/images/emc/link.svg';

class EMCFound extends Component {
    handleClick() {
      window.open(this.props.url, '_blank');
    }

    render() {
        return (
            <div className="search-results">
                <div className="search-result">
                    <div className="icon-css">
                        <img className="mb-3" src={verifiedImg} alt="verified"/>
                    </div>
                    <div className="result-title">E-MC Verified!</div>
                    <div className="result-subtitle">The E-MC is verified and issued by our trusted healthcare partners.<br/>View the full document via the link below.</div>
                </div>
                <div className="emc-link-container">
                    <a className="emc-link" href={this.props.url} target="_blank" rel="noopener noreferrer">
                        {this.props.url}
                    </a>
                    <button className="btn btn-link" onClick={() => {navigator.clipboard.writeText(this.props.url)}}><img src={linkImg} alt="link-img"/></button>
                </div>
            </div>
        )
    }
}

export default EMCFound;
